import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

import Radio from './input/Radio'
import Number from './input/Number'

const CardCorners = (props) => {
  let { formControls, handleChange } = props

  return (
    <div className="c-personalizer-card">

      <div className="c-personalizer-card__header">
        <h3 className="c-personalizer-card__title">2. Uitsnedes</h3>
      </div>
      
      <div class="c-personalizer-row">
        <p class="c-personalizer-row__title">Moet de mat worden bijgesneden?</p>
        <p class="c-personalizer-row__comment">Telefonisch bespreken we de precieze hoeken zodat de mat straks op de mm nauwkeurig past. Als we de hoeken vooraf in kunnen snijden zijn de kosten per hoek gemiddeld 9,075 euro (inclusief btw). Als we de mat niet vooraf kunnen insnijden geven we je graag een prijs voor het leggen van de mat bij jouw op locatie. Je kunt er ook voor kiezen zelf de mat bij te snijden door ons mattenmes van 3,95 euro (inclusief btw) te kopen in de volgende stap.</p>
        <Radio name="hasCorners"
          value={formControls.hasCorners.value}
          onChange={handleChange}
          options={formControls.hasCorners.options}
          touched={formControls.hasCorners.touched}
          valid={formControls.hasCorners.valid}
          error={formControls.hasCorners.error}
        />
        
        { formControls.hasCorners.value === 'Ja' ? (
          <div>
            <p class="c-personalizer-row__label">Schatting aantal uitsneden</p>
            <div class="c-personalizer-row__max-width">
              <Number name="corners" 
                placeholder={formControls.corners.placeholder}
                value={formControls.corners.value}
                onChange={handleChange}
                touched={formControls.corners.touched}
                valid={formControls.corners.valid}
                step={formControls.corners.validationRules.step}
                error={formControls.corners.error}
              />
            </div>
          </div>
        ) : null }
        
      </div>
      
      <div class="c-personalizer-row">
        <p class="c-personalizer-row__title">Snijmes toevoegen</p>
        <p class="c-personalizer-row__comment">Snij eenvoudig en snel je mat op maat met ons mattenmes.</p>
        <Radio name="cutter"
          value={formControls.cutter.value}
          onChange={handleChange}
          options={formControls.cutter.options}
          touched={formControls.cutter.touched}
          valid={formControls.cutter.valid}
          error={formControls.cutter.error}
        />
      </div>

    </div>
  )
}

export default CardCorners



// WEBPACK FOOTER //
// ./src/js/personalizer/components/CardCorners.js